module.exports = __webpack_public_path__ + "img/continue-button.e6947eb6.png";